
import React from "react";
import { ComboBox, ComboBoxChangeEvent, ComboBoxCloseEvent, ComboBoxFilterChangeEvent  } from "@progress/kendo-react-dropdowns";
import "./autodropdown.scss";
import { filterBy, FilterDescriptor } from "@progress/kendo-data-query";

// interface to declare all our prop types
interface Props {
    data?: {id: number, name: string}[];
    placeholder?:string;
    value?: string
    onClose?: any
    handleChange?: any
    dataItemKey?: string
    filterable?:boolean
    name?: string
    id?: string
}

const AutoDropdownSelect: React.FC<Props> = ({
    data = [],
    placeholder = '',
    // value= '',
    // onChange,
    handleChange,
    filterable,
    name,
    id,
  ...rest
}) => {
  

  const [value, setValue] = React.useState<string>('');
  const [item, setItem] = React.useState(data.slice());

  const filterData = (filter: FilterDescriptor) => {
    const item = data.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event: ComboBoxFilterChangeEvent) => {
    setItem(filterData(event.filter));
  };

  const onChange = (event: ComboBoxCloseEvent) => {
    setValue(event.target.value)
    handleChange(event.target.value)
  };

  const onClose = (event: ComboBoxChangeEvent) => {
    setValue(event.target.value)
  }

  const focusedItemIndex = (data: any, inputText: any, textField: any) => {
    let text = inputText.toLowerCase();
    return data.findIndex((item: any) =>
        String(textField ? item[textField] : item).toLowerCase().includes(text));
};

  return (
    <div className="autodropdown">
        <ComboBox placeholder={placeholder} 
          data={item} 
          textField={name}
          dataItemKey={id}
          filterable={true}
          onFilterChange={filterChange}
          value={value}
          focusedItemIndex={focusedItemIndex}
          onClose={onChange}
          onChange={onClose}
        />
    </div>
  );
};

export default AutoDropdownSelect;


